module.exports = __webpack_public_path__ + "static/media/CONECTAR-IGUALDAD_Color_SM_FondoTransparente.f4c795a9.svg";